export default [
    /*HoangTM - Giao ban*/
    {
        path: "briefingsconclusion",
        name: "Giao ban",
        redirect: "briefingsconclusion/list",
        component: {
            render(c) {
                return c("router-view");
            },
        },
        children: [
            {
                path: "list",
                name: "Kết luận giao ban",
                component: () =>
                    import(
                        "@/views/screens/briefings/BriefingsConclusion"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Tra cứu kết luận giao ban"
                },
            },
            {
                path: "create",
                name: "Thêm kết luận",
                component: () =>
                    import(
                        "@/views/screens/briefings/BriefingsConclusionCreate"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Thêm kết luận giao ban"
                },
            },
            {
                path: "edit/:id",
                name: "Sửa thông tin kết luận",
                component: () =>
                    import(
                        "@/views/screens/briefings/BriefingsConclusionEdit"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Thêm kết luận giao ban"
                },
            },
        ],
    },
    /*End*/
    /*HoangTM - Gửi nội dung giao ban*/
    {
        path: "briefingsreport",
        name: "Gửi nội dung giao ban",
        redirect: "briefingsreport/list",
        component: {
            render(c) {
                return c("router-view");
            },
        },
        children: [
            {
                path: "list",
                name: "Nội dung giao ban",
                component: () =>
                    import(
                        "@/views/screens/briefings/BriefingsReport"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Tra cứu báo cáo trước giao ban"
                },
            },
            {
                path: "create",
                name: "Thêm nội dung giao ban",
                component: () =>
                    import(
                        "@/views/screens/briefings/BriefingsReportCreate"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Thêm báo cáo trước giao ban"
                },
            },
            {
                path: "edit/:id",
                name: "Sửa nội dung giao ban",
                component: () =>
                    import(
                        "@/views/screens/briefings/BriefingsReportEdit"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Sửa báo cáo trước giao ban"
                },
            },
        ],
    },
    /*Sonda - Dự thảo giao ban*/
    {
        path: "briefingsdraft",
        name: "Dự thảo kết luận giao ban",
        redirect: "briefingsdraft/list",
        component: {
            render(c) {
                return c("router-view");
            },
        },
        children: [
            {
                path: "list",
                name: "Danh sách dự thảo",
                component: () =>
                    import(
                        "@/views/screens/briefings/BriefingDraftConclusion"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Tra cứu dự thảo KL giao ban"
                },
            },
            {
                path: "create",
                name: "Thêm dự thảo",
                component: () =>
                    import(
                        "@/views/screens/briefings/BriefingDraftConclusionCreate"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Thêm dự thảo KL giao ban"
                },
            },
            {
                path: "edit/:id",
                name: "Sửa dự thảo",
                component: () =>
                    import(
                        "@/views/screens/briefings/BriefingDraftConclusionEdit"
                    ),
                meta: {
                    requiresAuth: true,
                    title: "Sửa dự thảo KL giao ban"
                },
            },
        ],
    },
    /*End*/
    /*HoangTM - Tổng hợp giao ban tháng*/
    {
        path: "briefingssummary",
        name: "Tổng hợp giao ban tháng",
        component: () =>
            import("@/views/screens/briefings/BriefingsSummary"),
        meta: {
            requiresAuth: true,
            title: "Tổng hợp giao ban tháng"
        },
    }
]